module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_photographer@3x-d4abaf008a9fba5fd4195b121c250a5f.webp";